import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Member, Venue } from '../../models';
import { MemberLookupComponent } from './member-lookup.component';

export interface MemberLookupResult {
  member?: Member;
  isReciprocal?: boolean;
  reciprocalVenueId?: string;
  reciprocalMemberNumber?: string;
}

@Injectable()
export class MemberLookupModalController {
  constructor(private modalCtrl: ModalController) {}

  public async show(options?: { venue?: Venue }): Promise<MemberLookupResult | undefined> {
    const modal = await this.modalCtrl.create({
      component: MemberLookupComponent,
      cssClass: 'member-lookup-modal',
      componentProps: { venue: options?.venue },
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    return data;
  }
}
